<template>
  <div>
    <div class="p-box">
      <div class="p-box__body">
        <div class="p-box">
          <header class="p-box__header">
            <h2 class="p-box__title">{{ $t('pages.CompaniesLocationStoresBulkEdit.header') }}</h2>
          </header>
          <div class="p-box__body">
            <div class="infoWrapper">
              <Info>
                {{ $t('pages.CompaniesLocationStoresBulkEdit.description1') }}
              </Info>
            </div>
            <div class="selectedStores">
              <i18n-t keypath="pages.CompaniesLocationStoresBulkUpdateWithGmb.selectedStoresCount" tag="p">
                <span class="selectedStores__link u-colorPrimary" @click="selectedStoresModal = true">{{ $tc('labels.storesCount', storeIdCount) }}</span>
              </i18n-t>
            </div>
            <ValidationObserver ref="form" tag="form">
              <form>
                <div class="forms">
                  <section class="p-box">
                    <header class="p-box__header sectionHeader">
                      <h3 class="p-box__title">{{ $t('pages.CompaniesLocationStoresBulkEdit.regularHour.label') }}</h3>
                    </header>
                    <div class="p-box__body">
                      <div class="infoWrapper">
                        <Info>
                          {{ $t('pages.CompaniesLocationStoresBulkEdit.regularHour.description1') }}
                        </Info>
                      </div>
                      <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                        <input
                          id="checkbox_regular_hours"
                          :checked="false"
                          class="c-checkbox__input"
                          type="checkbox"
                          @change="toggleSetRegularHours"
                        >
                        <label class="c-checkbox__label" for="checkbox_regular_hours">{{
                          $t('pages.CompaniesLocationStoresBulkEdit.regularHour.checkBoxLabel') }}</label>
                      </fieldset>
                      <div v-if="showForms.regularHour" class="c-grid">
                        <div class="c-grid__items">
                          <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__10 c-grid__item__l__10">
                            <section v-for="(regular_hour, i) in innerStoreRegularHours" :key="'RegularHour' + i" class="p-box regular-hour-card">
                              <RegularHourCard hour-type="regular" :regular-hour="regular_hour.attributes" :index="'RegularHour' + i" :available-option="includeFoodBrand" />
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <KkBox :title="$t('pages.CompaniesLocationStoresBulkEdit.holidayHour.label')" border :header-bottom-border="false" class="section businessHour__box">
                    <template #content>
                      <div class="infoWrapper">
                        <KkInfo>
                          {{ $t('pages.CompaniesLocationStoresBulkEdit.holidayHour.description1') }}
                        </KkInfo>
                      </div>
                      <KkCheckbox
                        id="checkbox_holiday_hours"
                        :model-value="false"
                        :label="$t('pages.CompaniesLocationStoresBulkEdit.holidayHour.checkBoxLabel')"
                        class="holidayHours__checkbox"
                        @update:modelValue="toggleSetHolidayHours"
                      />
                      <div v-if="showForms.holidayHour" class="c-grid">
                        <div class="c-grid__items">
                          <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__10 c-grid__item__l__10">
                            <section v-if="innerStoreHolidayHour" class="p-box regular-hour-card">
                              <RegularHourCard hour-type="holiday" :regular-hour="innerStoreHolidayHour" index="HolidayHour" at-bulk :available-option="includeFoodBrand" />
                            </section>
                            <section v-if="innerStoreDayBeforeHolidayHour" class="p-box regular-hour-card">
                              <RegularHourCard hour-type="dayBeforeHoliday" :regular-hour="innerStoreDayBeforeHolidayHour" index="dayBeforeHolidayHour" at-bulk :available-option="includeFoodBrand" />
                            </section>
                          </div>
                        </div>
                      </div>
                    </template>
                  </KkBox>
                  <KkBox :title="$t('pages.CompaniesLocationStoresBulkEdit.wdayIndexRegularHour.label')" border :header-bottom-border="false" class="section businessHour__box">
                    <template #content>
                      <div class="infoWrapper">
                        <KkInfo>
                          {{ $t('pages.CompaniesLocationStoresBulkEdit.wdayIndexRegularHour.description1') }}
                        </KkInfo>
                      </div>
                      <KkCheckbox
                        id="checkbox_wdayIndexRegularHour_hours"
                        :model-value="false"
                        :label="$t('pages.CompaniesLocationStoresBulkEdit.wdayIndexRegularHour.checkBoxLabel')"
                        class="wdayIndexRegularHour__checkbox"
                        @update:modelValue="toggleSetWdayIndexRegularHour"
                      />
                      <template v-if="showForms.wdayIndexHour">
                        <div class="c-grid specialHours">
                          <div class="c-grid__items">
                            <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                              <section v-for="(wdayIndexRegularHour, i) in innerStoreWdayIndexRegularHours" :key="i" class="p-box">
                                <KkWdayIndexRegularHourCard
                                  :business-hour="wdayIndexRegularHour"
                                  :index="'wdayIndexRegularHour_' + i"
                                  :can-remove="innerStoreWdayIndexRegularHours.length > 1"
                                  at-bulk
                                  :available-option="includeFoodBrand"
                                  @removeSetting="removeWdayIndexRegularHour(i)"
                                />
                              </section>
                              <KkAddLabel
                                :label="$t('pages.CompaniesLocationStore.businessHours.wdayIndexRegularHours.addSetting')"
                                @click="addWdayIndexRegularHour"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </KkBox>
                  <KkBox :title="$t('pages.CompaniesLocationStoresBulkEdit.regularHourAdditionalDescription.label')" border :header-bottom-border="false" class="section businessHour__box">
                    <template #content>
                      <div class="infoWrapper">
                        <KkInfo>
                          {{ $t('pages.CompaniesLocationStoresBulkEdit.regularHourAdditionalDescription.description1') }}
                        </KkInfo>
                      </div>
                      <KkCheckbox
                        id="checkbox_regularHourAdditionalDescription_hours"
                        :model-value="false"
                        :label="$t('pages.CompaniesLocationStoresBulkEdit.regularHourAdditionalDescription.checkBoxLabel')"
                        class="regularHourAdditionalDescription__checkbox"
                        @update:modelValue="toggleSetRegularHourAdditionalDescription"
                      />
                      <template v-if="showForms.additionalDescription">
                        <div class="c-grid specialHours">
                          <div class="c-grid__items">
                            <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                              <div>
                                <ValidationProvider key="storeBusinessHoursRegularHolidayAdditionalDescription" v-slot="{ errors, value, handleChange }" v-model="innerStoreRegularHolidayAdditionalDescription" name="定休日の補足" rules="max:60">
                                  <label class="c-formLabel">{{ $t('pages.CompaniesLocationStore.businessHours.additionalExplanation.regularHoliday') }}({{ $t('labels.countCharacters', {count: innerStoreRegularHolidayAdditionalDescription.length, max: 60}) }}){{ $t('labels.optionalLabel') }}</label>
                                  <KkTextarea :model-value="value" placeholder="" @update:model-value="handleChange" />
                                  <ValidationError :error="errors[0]" />
                                </ValidationProvider>
                              </div>
                              <div class="businessHour__additionalDescription">
                                <ValidationProvider key="storeBusinessHoursRegularHourAdditionalDescription" v-slot="{ errors, value, handleChange }" v-model="innerStoreRegularHourAdditionalDescription" name="営業時間の補足" rules="max:120">
                                  <label class="c-formLabel">{{ $t('pages.CompaniesLocationStore.businessHours.additionalExplanation.businessHours') }}({{ $t('labels.countCharacters', {count: innerStoreRegularHourAdditionalDescription.length, max: 120}) }}){{ $t('labels.optionalLabel') }}</label>
                                  <KkTextarea :model-value="value" placeholder="" @update:model-value="handleChange" />
                                  <ValidationError :error="errors[0]" />
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </KkBox>
                  <section class="p-box">
                    <header class="p-box__header sectionHeader">
                      <h3 class="p-box__title">{{ $t('pages.CompaniesLocationStoresBulkEdit.specialHour.label') }}</h3>
                    </header>
                    <div class="p-box__body">
                      <div>
                        <div class="infoWrapper">
                          <Info>
                            {{ $t('pages.CompaniesLocationStoresBulkEdit.specialHour.description1') }}
                          </Info>
                        </div>
                        <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                          <input
                            id="checkbox_special_hours"
                            :checked="false"
                            class="c-checkbox__input"
                            type="checkbox"
                            @change="toggleSetSpecialHours"
                          >
                          <label class="c-checkbox__label" for="checkbox_special_hours">{{
                            $t('pages.CompaniesLocationStoresBulkEdit.specialHour.checkBoxLabel') }}</label>
                        </fieldset>
                        <template v-if="showForms.specialHour">
                          <div class="c-grid specialHours">
                            <div class="c-grid__items">
                              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                                <section v-for="(specialHour, i) in innerStoreSpecialHours" :key="i" class="p-box">
                                  <SpecialHourCard :special-hour="specialHour" :i="i" :display-delete-btn="innerStoreSpecialHours.length > 1" @remove-special-hour="removeStoreSpecialHour" />
                                </section>
                                <div class="specialHourAdd c-button c-button--icon">
                                  <div class="c-button__item c-button__item--primary" @click="addSpecialHour">
                                    <Icon name="iconPlusRed" class="c-button__icon" />
                                    <span>{{ $t('labels.add', { value: $t('pages.CompaniesLocationStore.businessHours.specialHours.elseDate') }) }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </section>
                  <!-- 決済手段 -->
                  <section class="p-box">
                    <header class="p-box__header sectionHeader">
                      <h3 class="p-box__title">{{ $t('pages.companies.location.stores.BulkEdit.paymentMethods.title') }}</h3>
                    </header>
                    <div class="p-box__body">
                      <div class="infoWrapper">
                        <KkInfo>
                          {{ $t('pages.companies.location.stores.BulkEdit.paymentMethods.description') }}
                        </KkInfo>
                      </div>
                      <div class="c-checkbox">
                        <fieldset class="c-checkbox__item">
                          <input
                            id="checkbox_payment_method"
                            :checked="false"
                            class="c-checkbox__input"
                            type="checkbox"
                            @change="toggleSetPaymentMethod"
                          >
                          <label class="c-checkbox__label" for="checkbox_payment_method">
                            {{ $t('pages.companies.location.stores.BulkEdit.paymentMethods.edit') }}
                          </label>
                        </fieldset>
                      </div>
                      <div v-if="showForms.paymentMethod" class="paymentMethods">
                        <KkPaymentMethodEdit
                          :payment-method="paymentMethod"
                          @change-attributes="paymentMethodsReducer"
                        />
                      </div>
                    </div>
                  </section>
                  <section class="p-box">
                    <header class="p-box__header sectionHeader">
                      <h3 class="p-box__title">{{ $t('pages.CompaniesLocationStoresBulkEdit.siteSetting.label') }}</h3>
                    </header>
                    <div class="p-box__body">
                      <div>
                        <div class="infoWrapper">
                          <Info>
                            {{ $t('pages.CompaniesLocationStoresBulkEdit.siteSetting.description1') }}
                          </Info>
                        </div>
                      </div>
                      <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                        <input
                          id="checkbox_site_setting"
                          :checked="false"
                          class="c-checkbox__input"
                          type="checkbox"
                          @change="toggleSiteSetting"
                        >
                        <label class="c-checkbox__label" for="checkbox_site_setting">{{
                          $t('pages.CompaniesLocationStoresBulkEdit.siteSetting.checkBoxLabel') }}</label>
                      </fieldset>
                      <div v-if="showForms.gmbWebSiteUrl" class="p-box__body">
                        <div class="p-formGrid__items">
                          <fieldset class="iconLabel p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                            <label class="c-formLabel">
                              <div class="c-icon c-icon--square">
                                <KkSiteIcon :name="google.siteType" />
                              </div>
                              <p>
                                {{ google.name }}
                              </p>
                            </label>
                          </fieldset>
                          <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                            <label class="c-formLabel">
                              <p>{{ $t('pages.CompaniesLocationStore.siteSetting.form.websiteUrl') }}</p>
                            </label>
                            <input v-model="storeGmbWebSiteUrl" type="url" class="c-textField" :placeholder="$t('labels.placeholder.basic')">
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section class="p-box">
                    <header class="p-box__header sectionHeader">
                      <h3 class="p-box__title">{{ $t('pages.CompaniesLocationStoresBulkEdit.gmbLocation.label') }}</h3>
                    </header>
                    <div class="p-box__body">
                      <div>
                        <div class="infoWrapper">
                          <Info>
                            <p>{{ $t('models.gmb.protection.description1') }}</p>
                            <p>{{ $t('models.gmb.protection.description2') }}</p>
                          </Info>
                        </div>
                      </div>
                      <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                        <input
                          id="checkbox_gmb_location"
                          :checked="false"
                          class="c-checkbox__input"
                          type="checkbox"
                          @change="toggleGmbLocation"
                        >
                        <label class="c-checkbox__label" for="checkbox_gmb_location">{{ $t('pages.CompaniesLocationStoresBulkEdit.gmbLocation.checkBoxLabel') }}</label>
                      </fieldset>
                      <div v-if="showForms.gmbLocation" class="storeGmbProtection">
                        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__8 c-grid__item__l__8">
                          <div :key="0" class="p-formGrid p-formGrid--border">
                            <div class="p-formGrid__items">
                              <div class="c-grid__item__s__12 storeGmbProtection__form">
                                <div class="p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                                  {{ $t('pages.CompaniesLocationStoresBulkEdit.gmbLocation.checkAll') }}
                                </div>
                                <div class="c-select p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                                  <select v-model="selectedAllLocationSynced" @change="changeAllLocationSynced">
                                    <option v-for="(status, i) in [ 'nc', 'on', 'off']" :key="i" :value="status">
                                      {{ $t('pages.CompaniesGMBLocationSyncLogs.status.' + status) }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <template v-if="selectedAllLocationSynced === 'nc'">
                            <div v-for="(item,k) in storeGmbLocation" :key="k + 1" class="p-formGrid p-formGrid--border">
                              <div class="p-formGrid__items">
                                <div class="c-grid__item__s__12 storeGmbProtection__form">
                                  <div class="p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                                    {{ item.name }}
                                  </div>
                                  <div class="c-select p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                                    <select :value="item.value" @change="storeGmbLocationReducer({ type: item.key, value: $event.target.value })">
                                      <option v-for="(status, i) in [ 'nc', 'on', 'off']" :key="i" :value="status">
                                        {{ $t('pages.CompaniesGMBLocationSyncLogs.status.' + status) }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div class="p-box__footer">
                  <div class="c-button c-button--right">
                    <router-link :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid }}" class="c-button__item c-button__item--outline-cancel">
                      {{ $t('labels.cancel') }}
                    </router-link>
                    <button class="c-button__item c-button__item--primary" @click.prevent="onConfirm">
                      {{ $t('labels.submitFilterCond') }}
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <KkDiffModal
      v-if="!isConnectedServicesLoading"
      :is-visible="modal"
      :query="query"
      :store-count="selectedStores.length"
      :connected-services="connectedServices.serviceTypes"
      :preview="bulkUpdatePreview"
      :loading="previewLoading"
      @close="modal = false"
      @submit="onSubmit"
    />
    <StoresModal
      v-if="selectedStoresModal"
      :header-label="$t('pages.CompaniesLocationStoresBulkUpdateWithGmb.selectedStores')"
      :store-names="selectedStores.map(s => s.attributes.name)"
      @close="selectedStoresModal = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapState as mapStatePinia, mapActions as mapActionsPinia } from 'pinia'
import RegularHourCard from '../../../../components/RegularHourCard'
import SpecialHourCard from '../../../../components/SpecialHourCard'
import { bulkEditDefaultRegularHours } from '../../../../modules/regularHour'
import { BulkEditPaymentMethodStatuses } from '../../../../modules/paymentMethodConst'
import StoresModal from '../../../../components/Modals/StoresModal'
import Info from '../../../../components/Info'
import cloneDeep from 'lodash.clonedeep'
import { google } from '../../../../modules/sitesConst'
import {basicDateFormat} from '../../../../modules/date'
import moment from 'moment'
import Icon from '../../../../components/Icon'
import ValidationError from '../../../../components/ValidationError'
import { KkPaymentMethodEdit, KkDiffModal } from '../../../../domains/bulkEdit'
import {KkBox, KkCheckbox, KkSiteIcon, KkTextarea} from '../../../../components/base'
import { KkAddLabel, KkInfo } from '../../../../components/ui'
import { KkWdayIndexRegularHourCard } from '../../../../components/domains/location/store/businessHour'
import { useCompaniesConnectedServices } from 'src/biz_spa/domains/connectedServices/stores'

export default {
  name: 'CompaniesLocationStoresBulkEdit',
  components: {
    KkDiffModal,
    StoresModal,
    RegularHourCard,
    SpecialHourCard,
    KkSiteIcon,
    Info,
    Icon,
    ValidationError,
    KkPaymentMethodEdit,
    KkBox,
    KkCheckbox,
    KkTextarea,
    KkInfo,
    KkAddLabel,
    KkWdayIndexRegularHourCard,
  },
  data() {
    return {
      modal: false,
      selectedStoresModal: false,
      innerStoreRegularHours: null,
      innerStoreHolidayHour: null,
      innerStoreDayBeforeHolidayHour: null,
      innerStoreWdayIndexRegularHours: [],
      innerStoreRegularHourAdditionalDescription: '',
      innerStoreRegularHolidayAdditionalDescription: '',
      innerStoreSpecialHours: [],
      paymentMethod: {
        storeCreditCard: {
          available: 'na',
          americanExpressAvailable: 'na',
          discoverAvailable: 'na',
          dinersClubAvailable: 'na',
          jcbAvailable: 'na',
          mastercardAvailable: 'na',
          unionPayAvailable: 'na',
          visaAvailable: 'na',
        },
        storeElectronicMoney: {
          available: 'na',
          idElectronicMoney: 'na',
          rakutenEdy: 'na',
          quicPay: 'na',
          waon: 'na',
          nanaco: 'na',
          auWallet: 'na',
          applePay: 'na',
        },
        storeTransportationElectronicMoney: {
          available: 'na',
          hayakaken: 'na',
          icoca: 'na',
          kitaca: 'na',
          nimoca: 'na',
          pasmo: 'na',
          pitapa: 'na',
          sapica: 'na',
          sugoca: 'na',
          suica: 'na',
          toica: 'na',
          manaca: 'na',
        },
        storeQrCodePayment: {
          available: 'na',
          auPay: 'na',
          dPay: 'na',
          paypay: 'na',
          rakutenPay: 'na',
          weChatPay: 'na',
          alipay: 'na',
        },
        storeCashOnly: { available: 'na' },
        storePayCheck: { available: 'na' },
        storeDebitCard: { available: 'na' },
      },
      storeGmbLocation: null,
      storeGmbWebSiteUrl: null,
      showForms: {
        regularHour: false,
        holidayHour: false,
        wdayIndexHour: false,
        additionalDescription: false,
        specialHour: false,
        paymentMethod: false,
        gmbWebSiteUrl: false,
        gmbLocation: false
      },
      selectedAllLocationSynced: 'nc'
    }
  },
  computed: {
    ...mapState({
      stores: state => state.companiesStores.data?.data,
      selectedStoreIds: state => state.companiesBulkUpdates.storeIds,
      includeHotelBrand: state => state.companiesBulkUpdates.includeHotelBrand,
      includeFoodBrand: state => state.companiesBulkUpdates.includeFoodBrand,
      diffLoading: state => state.companiesBulkUpdates.loading,
      previewLoading: state => state.companiesBulkUpdates.previewLoading,
      rawDifferencesData: state => state.companiesBulkUpdates.data,
      bulkUpdatePreview: state => state.companiesBulkUpdates.preview,
    }),
    ...mapStatePinia(useCompaniesConnectedServices, {
      connectedServices : 'connectedServices',
      isConnectedServicesLoading: 'isLoading',
    }),
    ...mapGetters({
      storeIdCount: 'companiesBulkUpdates/storeIdCount',
    }),
    storeRegularHours() {
      return this.innerStoreRegularHours.map(v => {
        v.attributes.open = v.attributes.periods.length !== 0
        return v
      })
    },
    storeHolidayRegularHour() {
      this.innerStoreHolidayHour.open = this.innerStoreHolidayHour.periods.length !== 0
      return this.innerStoreHolidayHour
    },
    storeDayBeforeHolidayRegularHour() {
      this.innerStoreDayBeforeHolidayHour.open = this.innerStoreDayBeforeHolidayHour.periods.length !== 0
      return this.innerStoreDayBeforeHolidayHour
    },
    storeWdayIndexRegularHours() {
      return this.innerStoreWdayIndexRegularHours.map(v => {
        v.open = v.periods.length !== 0
        return v
      })
    },
    storeSpecialHours() {
      return this.innerStoreSpecialHours.map(v => {
        v.open = v.periods.length !== 0
        return v
      })
    },
    paymentMethodStatuses: () => BulkEditPaymentMethodStatuses,
    companyUuid() {
      return this.$route.params.company_uuid
    },
    // 決済手段項目に「未設定」の選択があるか
    hasNaPaymentMethod() {
      let naFlag = false
      for (const i of Object.keys(this.paymentMethod)) {
        // 「未設定」の場合はその時点で処理を抜ける
        if (this.paymentMethod[i].available === 'na') {
          naFlag = true
          break
        }
        // 「利用可」の場合は各ブランドの値も確認
        if (this.paymentMethod[i].available === 'ok') {
          for (const j of Object.values(this.paymentMethod[i])) {
            if (j === 'na') {
              naFlag = true
              break
            }
          }
        }
      }
      return naFlag
    },
    google: () => google,
    query() {
      let holidayRegularHour = !this.storeHolidayRegularHour.noChange ? this.storeHolidayRegularHour : undefined
      if (holidayRegularHour) {
        delete holidayRegularHour.isNotSet
        delete holidayRegularHour.noChange
      }

      let dayBeforeHolidayRegularHour = !this.storeDayBeforeHolidayRegularHour.noChange ? this.storeDayBeforeHolidayRegularHour : undefined
      if (dayBeforeHolidayRegularHour) {
        delete dayBeforeHolidayRegularHour.isNotSet
        delete dayBeforeHolidayRegularHour.noChange
      }

      let location = {}
      this.storeGmbLocation.filter(v => v.value !== 'nc').forEach(v => {
        location[v.key] = v.value === 'on'
      })

      let siteSetting = {}
      if(this.storeGmbWebSiteUrl) siteSetting['store_gmb_site_setting'] = { web_site_url: this.storeGmbWebSiteUrl }

      const query = {
        store_regular_hours: this.storeRegularHours.filter(v => !v.attributes.noChange).map(v => {
          delete v.attributes.isNotSet
          delete v.attributes.noChange
          return v.attributes
        }),
        store_special_hours: this.storeSpecialHours.filter(v => !v.noChange).map(v => v),
        store_holiday_regular_hour: holidayRegularHour,
        store_day_before_holiday_regular_hour: dayBeforeHolidayRegularHour,
        store_wday_index_regular_hours: this.storeWdayIndexRegularHours.filter(v => !v.noChange).map(v => {
          delete v.isNotSet
          delete v.noChange
          return v
        }),
        store_regular_hour_additional_description: this.innerStoreRegularHourAdditionalDescription ? { context: this.innerStoreRegularHourAdditionalDescription } : undefined,
        store_regular_holiday_additional_description: this.innerStoreRegularHolidayAdditionalDescription ? { context: this.innerStoreRegularHolidayAdditionalDescription } : undefined,
        store_gmb_location: location,
        store_site_setting: siteSetting
      }

      if (this.showForms.paymentMethod) {
        let creditCard = {}
        let electronicMoney = {}
        let transportationElectronicMoney = {}
        let qrCodePayment = {}
        let cashOnly = {}
        let payCheck = {}
        let debitCard = {}
        for(const [key, value] of Object.entries(this.paymentMethod.storeCreditCard)) {
          if (value === '') continue
          creditCard[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storeElectronicMoney)) {
          if (value === '') continue
          electronicMoney[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storeTransportationElectronicMoney)) {
          if (value === '') continue
          transportationElectronicMoney[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storeQrCodePayment)) {
          if (value === '') continue
          qrCodePayment[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storePayCheck)) {
          if (value === '') continue
          payCheck[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storeCashOnly)) {
          if (value === '') continue
          cashOnly[key] = value
        }
        for(const [key, value] of Object.entries(this.paymentMethod.storeDebitCard)) {
          if (value === '') continue
          debitCard[key] = value
        }
        query.store_credit_card = creditCard
        query.store_electronic_money = electronicMoney
        query.store_transportation_electronic_money = transportationElectronicMoney
        query.store_qr_code_payment = qrCodePayment
        query.store_cash_only = cashOnly
        query.store_pay_check = payCheck
        query.store_debit_card = debitCard
      }

      return query
    },
    selectedStores() {
      return this.stores.filter(s => this.selectedStoreIds.includes(s.id))
    }
  },
  created() {
    if (!this.$route.params.storeIds || this.$route.params.storeIds.length === 0) this.$router.push({ name: 'CompaniesLocationStores' })

    this.readCompaniesConnectedServices({ companyUuid: this.companyUuid })

    this.initData()
    this.setStoreIds(this.$route.params.storeIds)
    this.setIncludeHotelBrands(JSON.parse(this.$route.params.selectedStoreIncludeHotelBrand.toLowerCase()))
    this.setIncludeFoodBrands(JSON.parse(this.$route.params.selectedStoreIncludeFoodBrand.toLowerCase()))
  },
  methods: {
    initData() {
      this.innerStoreRegularHours = cloneDeep(bulkEditDefaultRegularHours)
      this.addHolidayHour()
      this.addDayBeforeHolidayHour()
      this.resetGmbLocation()
    },
    ...mapActions({
      setStoreIds: 'companiesBulkUpdates/setStoreIds',
      setIncludeHotelBrands: 'companiesBulkUpdates/setIncludeHotelBrand',
      setIncludeFoodBrands: 'companiesBulkUpdates/setIncludeFoodBrands',
      bulkUpdate: 'companiesBulkUpdates/bulkUpdate',
      createBulkUpdatePreview: 'companiesBulkUpdates/createBulkUpdatePreview',
    }),
    ...mapActionsPinia(useCompaniesConnectedServices, ['readCompaniesConnectedServices']),
    paymentMethodsReducer({ type, target, value }) {
      this.paymentMethod[type][target] = value
    },
    storeGmbLocationReducer({ type, value }) {
      this.storeGmbLocation = this.storeGmbLocation.map(v => {
        if (v.key === type) v.value = value
        return v
      })
    },
    changeAllLocationSynced() {
      if(this.selectedAllLocationSynced !== 'nc') {
        this.storeGmbLocation = this.storeGmbLocation.map(v => {
          v.value = this.selectedAllLocationSynced
          return v
        })
      } else {
        this.resetGmbLocation()
      }
    },
    addHolidayHour() {
      this.innerStoreHolidayHour = {
        periods: [],
        noChange: true,
        open: false
      }
    },
    addDayBeforeHolidayHour() {
      this.innerStoreDayBeforeHolidayHour = {
        periods: [],
        noChange: true,
        open: false
      }
    },
    addWdayIndexRegularHour() {
      this.innerStoreWdayIndexRegularHours.push({
        periods: [],
        indexes: [],
        wdays: [],
        noChange: true,
        open: false
      })
    },
    addSpecialHour() {
      this.innerStoreSpecialHours.push({periods: [], date: basicDateFormat(moment()), noChange: true, open: false})
    },
    toggleSetRegularHours() {
      this.showForms.regularHour = !this.showForms.regularHour
      if (!this.showForms.regularHour) { this.innerStoreRegularHours = cloneDeep(bulkEditDefaultRegularHours) }
    },
    toggleSetHolidayHours() {
      this.showForms.holidayHour = !this.showForms.holidayHour
      if (!this.showForms.holidayHour) { this.removeAllInnerHolidayHour() }
      if (!this.innerStoreHolidayHour) { this.addHolidayHour() }
      if (!this.innerStoreDayBeforeHolidayHour) { this.addDayBeforeHolidayHour() }
    },
    toggleSetWdayIndexRegularHour() {
      this.showForms.wdayIndexHour = !this.showForms.wdayIndexHour
      if (!this.showForms.wdayIndexHour) { this.removeAllInnerWdayIndexRegularHour() }
      if (this.innerStoreWdayIndexRegularHours.length === 0) { this.addWdayIndexRegularHour() }
    },
    toggleSetRegularHourAdditionalDescription() {
      this.showForms.additionalDescription = !this.showForms.additionalDescription
      if (!this.showForms.additionalDescription) { this.removeAllAdditionalDescription() }
    },
    toggleSetSpecialHours() {
      this.showForms.specialHour = !this.showForms.specialHour
      if (!this.showForms.specialHour) { this.removeAllInnerSpecialHour() }
      if (this.innerStoreSpecialHours.length === 0) { this.addSpecialHour() }
    },
    toggleSetPaymentMethod() {
      this.showForms.paymentMethod = !this.showForms.paymentMethod
    },
    toggleSiteSetting() {
      this.showForms.gmbWebSiteUrl = !this.showForms.gmbWebSiteUrl
      if (!this.showForms.gmbWebSiteUrl) { this.storeGmbWebSiteUrl = null }
    },
    toggleGmbLocation() {
      this.showForms.gmbLocation = !this.showForms.gmbLocation
      if (!this.showForms.gmbLocation) {
        this.selectedAllLocationSynced = 'nc'
        this.resetGmbLocation()
      }
    },
    resetGmbLocation() {
      this.storeGmbLocation = [
        {
          name: this.$t('pages.CompaniesGMBLocationSyncLogs.kindLabels.locationName'),
          value: 'nc',
          key: 'name_synced',
        },
        {
          name: this.$t('pages.CompaniesGMBLocationSyncLogs.kindLabels.addressLines'),
          value: 'nc',
          key: 'address_synced',
        },
        {
          name: this.$t('models.store.phone'),
          value: 'nc',
          key: 'phone_synced',
        },
        {
          name: this.$t('pages.CompaniesGMBLocationSyncLogs.kindLabels.description'),
          value: 'nc',
          key: 'description_synced',
        },
        {
          name: this.$t('pages.CompaniesGMBLocationSyncLogs.kindLabels.regularHours'),
          value: 'nc',
          key: 'business_hours_synced',
        },
        {
          name: this.$t('pages.CompaniesLocationStore.siteSetting.form.websiteUrl') ,
          value: 'nc',
          key: 'website_url_synced',
        },
        {
          name: this.$t('models.storePaymentMethod.modelName'),
          value: 'nc',
          key: 'payment_method_synced',
        },
        {
          name: this.$t('pages.CompaniesGMBLocationSyncLogs.kindLabels.primaryCategory'),
          value: 'nc',
          key: 'category_synced',
        },
        {
          name: this.$t('models.gmbOpenInfo.modelName'),
          value: 'nc',
          key: 'open_info_synced',
        },
      ]
    },
    removeAllInnerHolidayHour() {
      this.innerStoreHolidayHour = null
      this.innerStoreDayBeforeHolidayHour = null
    },
    removeAllInnerWdayIndexRegularHour() {
      this.innerStoreWdayIndexRegularHours = []
    },
    removeAllInnerSpecialHour() {
      this.innerStoreSpecialHours = []
    },
    removeWdayIndexRegularHour(key) {
      this.innerStoreWdayIndexRegularHours.splice(key, 1)
    },
    removeAllAdditionalDescription() {
      this.innerStoreRegularHourAdditionalDescription = ''
      this.innerStoreRegularHolidayAdditionalDescription = ''
    },
    removeStoreSpecialHour(key) {
      this.innerStoreSpecialHours.splice(key, 1)
    },
    async onConfirm() {
      const result = await this.$refs.form.validate()
      if (!result.valid) {
        alert(this.$t('messages.invalid'))
        return
      }
      this.createBulkUpdatePreview({ companyUuid: this.companyUuid, query: this.query })
      this.modal = true
    },
    async onSubmit() {
      if (this.hasNaPaymentMethod) {
        const confirmResult = confirm(this.$t('pages.companies.location.stores.BulkEdit.alert'))
        if (!confirmResult) return
      }

      const result = await this.$refs.form.validate()
      if (!result.valid) {
        alert(this.$t('messages.invalid'))
        return
      }
      this.modal = false
      this.bulkUpdate({ companyUuid: this.companyUuid, query: this.query })
        .then(() => {
          this.$router.push({ name: 'CompaniesLocationStores' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.p-modalLikeBox {
  &__header__text {
    color: #FFFFFF;
    background: rgba(58, 59, 63, 1);
  }
}
.forms {
  margin-top: 24px;
}
.p-modalLikeBox:not(:last-of-type) {
  margin-bottom: 32px;
}
.regular-hour-card {
  margin: 32px;
}
.storeGmbProtection {
  margin: 32px;
  &__form {
    vertical-align: baseline;
    justify-content: center;
    align-items: center;
    display: flex;
  }
}
.selectedStores {
  margin-bottom: 8px;
  &__link {
    text-decoration: none;
    cursor: pointer;
  }
}
.infoWrapper {
  margin-bottom: 24px;
}
.sectionHeader {
  border: none;
}
.p-formGrid__item {
  padding: 0 8px;
}
.iconLabel {
  padding: 0 8px 20px;
}
.specialHours {
  margin-top: 32px;
}
.c-select {
  select {
    padding: 12px 48px 12px 12px;
  }
}
.businessHour {
  &__box {
    margin-top: 16px;
  }
  &__checkbox {
    margin-top: 24px;
  }
  &__additionalDescription {
    margin-top: 32px;
  }
}
.paymentMethods {
  width: 596px;
  max-width: 100%;
}
</style>
